import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { TableRow, TableCell } from '@mui/material';
import { confirmDialog } from '../Reusable/ConfirmDialog';
import ModalForUpdateUserRole from './ModalForUpdateUserRole';

const UserRoleRow = ({
  role,
  updateUserRole,
  deleteUserRole,
  dispatch,
  userRoleReducer,
  clearValidationErrors,
}) => {
  const [show, setShow] = useState(false);

  const onDeleteClick = (id) => {
    const action = () => {
      dispatch(deleteUserRole(id));
    };
    confirmDialog('obrišete rolu', action, ', obriši!');
  };

  const showModalUpdate = () => {
    setShow(true);
  };

  const handlePreviewClose = () => {
    setShow(false);
    clearValidationErrors();
  };

  const handleEdit = (role) => {
    dispatch(updateUserRole(role, handlePreviewClose));
  };

  let row = (
    <>
      <TableRow>
        <TableCell>{role.roleName}</TableCell>

        <TableCell className="text-center" id="centerRow">
          <Link to="#" onClick={() => showModalUpdate()}>
            <i className="fas fa-edit fa-2x i" />
          </Link>
        </TableCell>
        <TableCell
          className={`text-center ${role.id === 2 && 'disable-events'}`}
        >
          <Link to="#" id="deleteUserRole" onClick={() => onDeleteClick(role.id)}>
            <i
              className={`fas fa-trash-alt fa-2x ${
                role.id === 2 && 'disable-color'
              }`}
            />
          </Link>
        </TableCell>
      </TableRow>
    </>
  );

  return (
    <>
      {row}

      {show && (
        <ModalForUpdateUserRole
          show={show}
          role={role}
          updateUserRole={handleEdit}
          handleClose={handlePreviewClose}
          userRoleReducer={userRoleReducer}
        />
      )}
    </>
  );
};

export default UserRoleRow;
